const enum BlockchainNetworkId {
  Ethereum = 1,
  FirstOasisKlaytn = -2,
  Klaytn = 8217,
  Counterparty = -1,
}

export default BlockchainNetworkId;
